import { render, staticRenderFns } from "./LayoutMoveable.vue?vue&type=template&id=206d5732&scoped=true&"
import script from "./LayoutMoveable.vue?vue&type=script&lang=js&"
export * from "./LayoutMoveable.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMoveable.vue?vue&type=style&index=0&id=206d5732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d5732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
